import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import _regeneratorRuntime from "@babel/runtime/regenerator";
export default function parseToHTMLImage(arrayBuffer, options) {
  var mimeType, blob, URL, objectUrl;
  return _regeneratorRuntime.async(function parseToHTMLImage$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          mimeType = 'image/jpeg';
          blob = new Blob([arrayBuffer], {
            type: mimeType
          });
          URL = self.URL || self.webkitURL;
          objectUrl = URL.createObjectURL(blob);
          _context.prev = 4;
          _context.next = 7;
          return _regeneratorRuntime.awrap(loadToHTMLImage(objectUrl, options));

        case 7:
          return _context.abrupt("return", _context.sent);

        case 8:
          _context.prev = 8;
          URL.revokeObjectURL(objectUrl);
          return _context.finish(8);

        case 11:
        case "end":
          return _context.stop();
      }
    }
  }, null, null, [[4,, 8, 11]]);
}
export function loadToHTMLImage(url, options) {
  var image;
  return _regeneratorRuntime.async(function loadToHTMLImage$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          image = new Image();
          image.src = url;

          if (!(options.image && options.image.decode && image.decode)) {
            _context2.next = 6;
            break;
          }

          _context2.next = 5;
          return _regeneratorRuntime.awrap(image.decode());

        case 5:
          return _context2.abrupt("return", image);

        case 6:
          _context2.next = 8;
          return _regeneratorRuntime.awrap(new Promise(function (resolve, reject) {
            try {
              image.onload = function () {
                return resolve(image);
              };

              image.onerror = function (err) {
                return reject(new Error("Could not load image ".concat(url, ": ").concat(err)));
              };
            } catch (error) {
              reject(error);
            }
          }));

        case 8:
          return _context2.abrupt("return", _context2.sent);

        case 9:
        case "end":
          return _context2.stop();
      }
    }
  });
}